import { DonutChartItem } from '@/design-system/components/charts/donutChart/DonutChart';
import { formatDate } from '@/utils/dateFormatting';

import { useMemo } from 'react';
import { useStore } from 'store/store';
import { BaseCurrency } from 'store/types';
import { useUtxEarnSubscriptionsGetOverview } from '@utx/utx-client';

interface OverviewResponse {
  nav: number;
  time: string;
  breakdown: Array<{
    amount: number;
    category: string;
    percentage: number;
  }>;
}

interface UseOverviewParams {}

export const useOverview = (params: UseOverviewParams) => {
  const store = useStore();
  const query = useUtxEarnSubscriptionsGetOverview(
    {
      currency: store.baseCurrency
    },
    {
      query: {
        keepPreviousData: true
      }
    }
  );

  const netAssetValue = useMemo(() => {
    const nav = query.data?.data?.nav;
    if (!nav) return '0';
    return nav.toString();
  }, [query.data?.data]);

  const lastUpdated = useMemo(() => {
    const time = query.data?.data?.time;
    if (!time) return ' - ';
    return formatDate(time);
  }, [query.data?.data]);

  function onChangeCurrency(value: BaseCurrency) {
    store.changeBaseCurrency(value);
  }

  function castDonutChartData(): Array<DonutChartItem['item']> {
    if (!query.data?.data) return [];
    const { breakdown } = query.data.data;
    if (breakdown.length === 0) return [];
    return breakdown.map((item) => ({
      name: item.category,
      percentage: item.percentage,
      value: item.amount?.toString() || '0'
    }));
  }

  return {
    data: castDonutChartData(),
    query,
    netAssetValue,
    currency: store.baseCurrency,
    lastUpdated,
    loading: (query.isLoading || query.isFetching) && !query.data?.data,
    onChangeCurrency
  };
};
